module.exports = __webpack_public_path__ + "img/EmergencyExpert.39704a88.png";